import { render } from "./OrderPartEditClient.vue?vue&type=template&id=29a81a8c&scoped=true"
import script from "./OrderPartEditClient.vue?vue&type=script&lang=js"
export * from "./OrderPartEditClient.vue?vue&type=script&lang=js"

import "./OrderPartEditClient.vue?vue&type=style&index=0&id=29a81a8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a81a8c"]])

export default __exports__